"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listProspectsApiResponseSchema = exports.prospectListItemSchema = void 0;
const zod_1 = require("zod");
const get_referral_program_1 = require("./get-referral-program");
exports.prospectListItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    email: zod_1.z.string(),
    phone: zod_1.z.string().nullable(),
    desiredCity: zod_1.z.string().nullable(),
    status: get_referral_program_1.prospectStatusSchema,
    /** Verbatim Airtable milestone; shown so an unmapped option stays visible. */
    rawStatus: zod_1.z.string(),
    /** Serialized by the API with `toISOString()`. */
    lastContactedAt: zod_1.z.string().datetime().nullable(),
    installedAt: zod_1.z.string().datetime().nullable(),
    syncedAt: zod_1.z.string().datetime(),
    /**
     * When the sync noticed Airtable had stopped returning this record; null
     * while the base still has it. Non-null means somebody deleted it upstream,
     * and is the only state from which staff may remove the row.
     */
    missingFromAirtableAt: zod_1.z.string().datetime().nullable(),
    /** Null when nobody referred them — the base also holds direct prospects. */
    parrainName: zod_1.z.string().nullable(),
    referredAt: zod_1.z.string().datetime().nullable(),
});
exports.listProspectsApiResponseSchema = zod_1.z.object({
    page: zod_1.z.number(),
    per_page: zod_1.z.number(),
    page_count: zod_1.z.number(),
    total: zod_1.z.number(),
    data: zod_1.z.array(exports.prospectListItemSchema),
});
